export enum RedirectComparisonType {
  EXACT_MATCH = 1,
  PREFIX_MATCH = 2,
  BACKWARD_MATCH = 3,
  PARTIAL_MATCH = 4,
}
